/**
 * FAQ structure for /2026-workshop About tab.
 * Copy lives in i18n catalogs: workshop.2026.faq.{id}.question / .answer
 */

export interface WorkshopFaqItem {
  id: string;
  /** When true, expanding shows ask-question UI instead of static answer */
  isAskQuestion?: boolean;
}

export const WORKSHOP_2026_FAQ: WorkshopFaqItem[] = [
  { id: 'what-is-workshop' },
  { id: 'who-is-it-for' },
  { id: 'open-to-everyone' },
  { id: 'sponsor' },
  { id: 'how-long' },
  { id: 'cost' },
  { id: 'weekly-session' },
  { id: 'registration' },
  { id: 'time-commitment' },
  { id: 'past-workshops' },
  { id: 'recovery-commons' },
  { id: 'privacy' },
  { id: 'ask', isAskQuestion: true },
];
